
    require('./gauge/GaugeSeries');
    require('./gauge/GaugeView');



//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/chart/gauge.js
// module id = 961
// module chunks = 0